<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 19 19"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <path
      d="M8.79225 16.3078H10.1578V15.0962C10.9334 14.9911 11.6357 14.6997 12.2645 14.222C12.8933 13.7445 13.2078 13.0205 13.2078 12.05C13.2078 11.35 13.0013 10.7308 12.5885 10.1923C12.1757 9.65392 11.3692 9.16808 10.1692 8.73475C9.11792 8.37575 8.41983 8.06483 8.075 7.802C7.73017 7.53917 7.55775 7.17183 7.55775 6.7C7.55775 6.22817 7.73433 5.84483 8.0875 5.55C8.44067 5.25517 8.92817 5.10775 9.55 5.10775C10.0705 5.10775 10.4903 5.2305 10.8095 5.476C11.1288 5.7215 11.3744 6.0295 11.5462 6.4L12.7807 5.90375C12.5717 5.37175 12.2311 4.91633 11.7587 4.5375C11.2863 4.15867 10.7692 3.94742 10.2078 3.90375V2.69225H8.84225V3.90375C7.98975 4.06792 7.335 4.41375 6.878 4.94125C6.42083 5.46892 6.19225 6.05517 6.19225 6.7C6.19225 7.45133 6.41983 8.05583 6.875 8.5135C7.33017 8.97117 8.07183 9.38458 9.1 9.75375C10.1628 10.1436 10.8888 10.4933 11.278 10.803C11.667 11.1125 11.8615 11.5282 11.8615 12.05C11.8615 12.677 11.6353 13.1324 11.1827 13.4163C10.7301 13.7003 10.2192 13.8422 9.65 13.8422C9.08717 13.8422 8.58367 13.6731 8.1395 13.3348C7.69517 12.9963 7.35375 12.5013 7.11525 11.85L5.85 12.3655C6.109 13.1077 6.48108 13.6973 6.96625 14.1345C7.45158 14.5717 8.06025 14.8756 8.79225 15.0462V16.3078ZM9.5 19C8.18717 19 6.95292 18.7503 5.79725 18.251C4.64142 17.7517 3.63592 17.0744 2.78075 16.2193C1.92558 15.3641 1.24833 14.3586 0.749 13.2028C0.249667 12.0471 0 10.8128 0 9.5C0 8.18717 0.249667 6.95292 0.749 5.79725C1.24833 4.64142 1.92558 3.63592 2.78075 2.78075C3.63592 1.92558 4.64142 1.24833 5.79725 0.749001C6.95292 0.249667 8.18717 0 9.5 0C10.8128 0 12.0471 0.249667 13.2028 0.749001C14.3586 1.24833 15.3641 1.92558 16.2193 2.78075C17.0744 3.63592 17.7517 4.64142 18.251 5.79725C18.7503 6.95292 19 8.18717 19 9.5C19 10.8128 18.7503 12.0471 18.251 13.2028C17.7517 14.3586 17.0744 15.3641 16.2193 16.2193C15.3641 17.0744 14.3586 17.7517 13.2028 18.251C12.0471 18.7503 10.8128 19 9.5 19ZM9.5 17.5C11.7333 17.5 13.625 16.725 15.175 15.175C16.725 13.625 17.5 11.7333 17.5 9.5C17.5 7.26667 16.725 5.375 15.175 3.825C13.625 2.275 11.7333 1.5 9.5 1.5C7.26667 1.5 5.375 2.275 3.825 3.825C2.275 5.375 1.5 7.26667 1.5 9.5C1.5 11.7333 2.275 13.625 3.825 15.175C5.375 16.725 7.26667 17.5 9.5 17.5Z"
      :fill="color"
    />
  </svg>
</template>
<script>
export default {
  name: 'BudgetTypeRecognition',
  props: {
    width: {
      type: [Number, String],
      required: false,
      default: 19,
    },
    height: {
      type: [Number, String],
      required: false,
      default: 19,
    },
    color: {
      type: String,
      required: false,
      default: '#62646A',
    },
  },
};
</script>
